// goalHelpers.js
import api from '../../Services/Api';

// helper function (add at top if you want)
const toYMD = (date) =>
  new Date(date).toISOString().split('T')[0];

export const calculateGoalProgress = async (goal) => {
  try {
    if (!goal || !goal.time_period || !goal.max_goal || !goal.start_date) {
      return { progress: 0, cleanDays: 0, totalDays: 0 };
    }

    const { time_period, max_goal, start_date, end_date } = goal;

    let endDate = end_date;

    if (!endDate) {
      const start = new Date(start_date);

      if (time_period === 'weekly') {
        start.setDate(start.getDate() + 6);
      } else if (time_period === 'monthly') {
        start.setDate(start.getDate() + 29);
      }

      endDate = start;
    }

    // 🔑 ALWAYS format before API call
    const startStr = toYMD(start_date);
    const endStr = toYMD(endDate);

    const response = await api.get(
      `stats/daily_logs/?start=${startStr}&end=${endStr}`
    );

    const logs = response.data.logs || [];
    const cleanDays = logs.filter(log => log.fap_count === 0).length;
    const progress = max_goal > 0 ? Math.min(100, (cleanDays / max_goal) * 100) : 0;

    return { progress, cleanDays, totalDays: logs.length };

  } catch (error) {
    console.error('Error calculating goal progress:', error);
    return { progress: 0, cleanDays: 0, totalDays: 0 };
  }
};

export const getDaysRemaining = (endDate) => {
    if (!endDate) return null;
    const end = new Date(endDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const diffTime = end - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return Math.max(0, diffDays);
};

export const getGoalStatus = (progress, daysRemaining) => {
    if (progress >= 100) return { status: 'completed', color: '#4CAF50', message: 'Completed!' };
    if (progress >= 80) return { status: 'on-track', color: '#8BC34A', message: 'Almost there!' };
    if (progress >= 50) return { status: 'good', color: '#FFC107', message: 'Good progress' };
    if (progress > 0) return { status: 'started', color: '#FF9800', message: 'Keep going' };
    return { status: 'not-started', color: '#9e9e9e', message: 'Get started' };
};

export const getGoalTypeLabel = (timePeriod) => {
    const labels = { weekly: 'Weekly', monthly: 'Monthly' };
    return labels[timePeriod] || timePeriod;
};

export const getGoalUnitLabel = (timePeriod) => {
    const units = {
        weekly: 'clean days/week',
        monthly: 'clean days/month'
    };
    return units[timePeriod] || 'units';
};